// React import
import React, { useEffect, useState, useCallback, useRef, Fragment } from "react";
// Material import
import { CircularProgress } from "@mui/material";
import { ListItem } from "@mui/material";
import Grid from '@mui/material/Grid2';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { TablePagination } from "@mui/material";
// custom component import
import { useMsal } from "@azure/msal-react";
import resetBtn from "../../../assets/images/resetBtn.png";
import Filters from "../../../assets/images/filters.svg";
// import bluePMinput from "../../../assets/images/pminputblue.jfif";
// import grayPMinput from "../../../assets/images/pminputgray.jfif";
import Excel from "../../../assets/images/Excel.svg";
import Slider from "../../../assets/images/sliders 1.svg";
import Plus from "../../../assets/images/Plus.svg";
import styles from "./prioritize.module.css";
import SnackBarMessage from "Samarth Module/components/snackbar/snackbar";
import ExportLoader from "Samarth Module/components/snackbar/exportLoader";
import CustomiseColumns from "Samarth Module/components/drawers/CustomiseColumns";
import MoreFilters from "Samarth Module/components/drawers/moreFilters";
import MultiSelectWithSearchInput from "../../components/dropdown/MultiSelectWithInput";
import OverflowMenu from "Samarth Module/components/overflowMenu/OverflowMenu";
import CustomButton from "Samarth Module/components/buttons/CustomButton";
import PrioritizeAddNewCBU from "./PrioritizeAddNewCBU";
import MatrixTable from "./MatrixTable";
import { transformFilters } from "utils/transformFilters";
import { getPrioritizationMatrix, updatePrioritizationMatrix, exportExcelFile } from "Samarth Module/api/PrioritizationMatrixAPI";
import { scheduleCleanup, getFilterDetails } from "utils/generateFilterObject";
// lazy loading import

const weekDropDownObj = {
    "label": "Week no.",
    "data": ['Week n+1', 'Week n+2'],
    "selectedData": []
};

const PriortizationMatrix = ()=>{
    //login user details
    const pageType = 'Prioritization Matrix';
    const { accounts } = useMsal();
    const activeAccount = accounts[0] || null;
    const clearFiltersRef = useRef(false);
    const [filterObject, setFilterObject] = useState([]);
    const [changeFilterObject, setChangeFilterObject] = useState([]);
    const [filterObjectOption, setFilterObjectOption] = useState({});
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [exportLoader, setExportLoader] = useState(false);
    const [moreFilterLoader, setMoreFilterLoader] = useState(false);
    const [customiseLoader, setCustomiseLoader] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [subTotal, setSubTotal] = useState({});
    const [tableColumns, setTableColumns] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedPriority, setSelectedPriority] = useState('Prio 1');
    const [weekNo, setWeekNo] = useState([]);
    // const [openInputDiv, setOpenInputDiv] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [totalRows, setTotalRows] = useState(0);
    const [initialLoad, setInitialLoad] = useState(true);
    const [firstApiCall, setFirstApiCall] = useState(true);
    const [afterAddRows, setAfterAddRows] = useState(0);
    const [sortBy, setSortBy] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [fieldSection, setFieldSection] = useState('');
    // const handleInputDiv = ()=>{
    //     setOpenInputDiv(prev => !prev);
    // };
    const [snackBarObject, setSnackBarObject] = useState({
        snackbarOpen: false,
        message: "",
        type: "error",
    });
    const handleMultiSelectChange = useCallback((label, values) => {
        //onchange API call
        let filterData = [...filterObject];
        let tempData = filterData?.map(filter => filter.label === label ? { ...filter, selectedData: values }: filter);
        
        // Check if there are any selected filters
        const hasSelection = tempData.some((filter) => {
            const selected = filter?.selectedData;
            if (Array.isArray(selected)) return selected.length > 0;
            if (typeof selected === 'string') return selected.trim().length > 0;
            return selected !== undefined && selected !== null;
        });
        
        clearFiltersRef.current = !hasSelection;
        setChangeFilterObject(tempData);
        setPage(0); // Reset to first page when filter changes

        setFilterObject(prev =>
            prev.map(filter => filter.label === label ? { ...filter, selectedData: values }: filter)
        );
    }, [filterObject]);    
    
    const resetFilter = useCallback(() => {
        clearFiltersRef.current = true;
        let filterData = [...filterObject];
        let tempData = filterData?.map(filter => ({ ...filter, selectedData: [] }));
        setChangeFilterObject(tempData);
        setPage(0); // Reset to first page when filters are reset
        setFilterObject(prev =>
            prev.map(filter => ({...filter, selectedData: []}))
        );
    }, [filterObject]);
    const handleCustomizeDrawer = useCallback(() => {
        setCustomiseLoader(prev=> !prev);
    }, []);
    const columnCustomization = useCallback((list) => {
        setTableColumns(list);
        setAfterAddRows((prev)=>prev + 1);
        setCustomiseLoader(false);
    }, []);
    const exportToExcel = useCallback(async () => {   
        try{
            setExportLoader(true);
            const transformedFilters = transformFilters(changeFilterObject);
            await exportExcelFile({"type": pageType, filterData: transformedFilters});
        }catch(error){
            setSnackBarObject({ snackbarOpen: true, message:error.message, type: "error" });
        } finally {
            setExportLoader(false);
        }
    }, [changeFilterObject]);
    const handleFilterDrawer = useCallback(() => {
        setMoreFilterLoader(prev=> !prev);
    }, []);
    const handleFilterDrawerClose = useCallback(() => {
        setMoreFilterLoader(false);
    }, []);
    const handleFiltersSaved = useCallback((updatedFilters) => {
        // Check if there are any selected filters
        const hasSelection = updatedFilters.some((filter) => {
            const selected = filter?.selectedData;
            if (Array.isArray(selected)) return selected.length > 0;
            if (typeof selected === 'string') return selected.trim().length > 0;
            return selected !== undefined && selected !== null;
        });
        
        clearFiltersRef.current = !hasSelection;
        setChangeFilterObject(updatedFilters);
        setPage(0); // Reset to first page when filters are saved
        setAfterAddRows((prev)=>prev + 1);
    }, []);
    const handlePriorityChange = useCallback((event)=>{setSelectedPriority(event.target.value);}, []);
    const handleWeeknoChange = useCallback((label, values) => {setWeekNo(values);}, []);
    //Close Alert message
    const closeSnackbar = useCallback(() => {
        setSnackBarObject((prev) => ({ ...prev, snackbarOpen: false }));
    }, []);
    // clean filter data
    useEffect(() => {
        scheduleCleanup();
    }, []);
    // API call for get filter details
    
    const getFilterOptionDetails = useCallback(async()=>{
        const resData =  await getFilterDetails(pageType, 'Detailed view',activeAccount.username,transformFilters(changeFilterObject));
        setFilterObjectOption(resData?.data?.filters || {});
        // setInitialLoad(false);
    }, [pageType,activeAccount?.username,changeFilterObject]);
    useEffect(() => {
        getFilterOptionDetails();
    }, [getFilterOptionDetails]);

    const generatePayload = useCallback(() => {
        const shouldClearFilters = clearFiltersRef.current;
        clearFiltersRef.current = false;
        const transformedFilters = transformFilters(changeFilterObject);
        return {
            email: activeAccount.username,
            type: pageType,
            role: activeAccount?.idTokenClaims?.roles,
            page: page + 1,
            per_page: rowsPerPage,
            filterData: transformedFilters,
            clearFilters: shouldClearFilters,
            sortBy: sortBy,
            sortOrder: sortOrder,
            fieldsection: fieldSection
        };
    }, [activeAccount, page, rowsPerPage, changeFilterObject, sortBy, sortOrder, fieldSection]);

    // Handle sorting from MatrixTable
    const handleTableSort = useCallback((columnKey, direction, weekSection = '') => {
        setSortBy(columnKey);
        setSortOrder(direction?.toUpperCase());
        setFieldSection(weekSection);
    }, []);
    //api call for table data, column, filter data on page load
    const fetchTableData = useCallback(async () => {
        setIsTableLoading(true);
        try{
            const payload = generatePayload();
            const responseData = await getPrioritizationMatrix(payload);
            setFilterObject(responseData?.filters || []);
            setTableColumns(responseData?.defaultColumns || []);
            setTableData(responseData?.prioritizationDetails || []);
            setSubTotal(responseData?.subtotals);
            setRowsPerPage(responseData?.pagination?.per_page || 25);
            setTotalRows(responseData?.pagination?.total);
        } catch (error) {
            setSnackBarObject({ snackbarOpen: true, message:error.message, type: "error" });
        }finally{
            setTimeout(() => {
                setFirstApiCall(false);            
                setIsTableLoading(false);
            }, 200);
        }
    }, [generatePayload]);

    useEffect(() => {
        if(!initialLoad){
            fetchTableData()
        }
        setInitialLoad(false);
    }, [fetchTableData, initialLoad, afterAddRows]);
    
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 25));
        setPage(0);
    };

    // add new CBU drawer Start
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const toggleDrawer = useCallback(() => {
        setIsDrawerOpen(prev=> !prev);
    }, []);
    // add new CBU drawer End

    // get the selected rows from child
    const getSelectedCheckBoxValue = useCallback((dataFromChild) => {
        setSelectedRows(dataFromChild);
    }, []);

    // update function
    const priortizationMatrixUpdate = useCallback(async (payload) => {
        try {
            setIsSubmit(true);
            //create update payload
            const transformedFilters = transformFilters(changeFilterObject);
            const updatePayload = {
                email: activeAccount.username,
                priority: selectedPriority,
                weekNo: weekNo.length === 0 ? weekDropDownObj?.data : weekNo,
                selectedRows: selectedRows?.length === tableData?.length ? 'All' : selectedRows,
                filterData: transformedFilters
            };
            // validate Payload
            if(selectedRows?.length === 0 && !payload){
                setSnackBarObject({ 
                    snackbarOpen: true, 
                    message:'Please select at least one row', 
                    type: "error" 
                });
            } else {
                // api call
                const responseData = await updatePrioritizationMatrix(payload ? payload : updatePayload);
                setSnackBarObject({ 
                    snackbarOpen: true, 
                    message:responseData?.message, 
                    type: responseData?.status 
                });
                if(!payload && responseData?.status === 'success') {fetchTableData()}
            }
        } catch(error){
            setSnackBarObject({ snackbarOpen: true, message:error?.message, type: "error" });
        } finally{
            setIsSubmit(false);
        }
    }, [selectedPriority, weekNo, selectedRows, tableData, fetchTableData, changeFilterObject, activeAccount]);
    const addAfter =()=>{
        getFilterOptionDetails();
        setAfterAddRows((prev)=>prev + 1);
    }

    const handlePriorityChangeByDropdown = (value, row, weekNo) => {
        setTableData((prevData) => {
            const updatedData = prevData.map((item) => {
                if (item.id === row.id) {
                    return { ...item, [weekNo]: { ...item[weekNo], Priority: value } };
                }
                return item;
            });
            return updatedData;
        });
        // API call for update
        const payload = {
            email: activeAccount.username,
            priority: value,
            weekNo: [weekNo.replace('Wk', 'Week')],
            selectedRows: [row.id],
            filterData: {}
        }
        priortizationMatrixUpdate(payload)
    }

    return(
        <Fragment>
            <div className={styles.mainContainer}>
                { firstApiCall ? 
                <div className={styles.loaderContainer}><CircularProgress /></div> : <>
                <div className={styles.filterDiv}>
                    {filterObject?.length > 0 && filterObject?.filter(filter => filter.isFavourite)?.map(filter => (
                        <ListItem key={filter.label} className={styles.listCustomClass}>
                        <MultiSelectWithSearchInput
                            key={filter.label}
                            label={filter.label}
                            options={filterObjectOption[filter.label]}
                            filterValues={filter.selectedData}
                            handleFilter={handleMultiSelectChange}
                            disabled={false}
                            isLabelShow={true}
                            type={pageType}
                        />
                        </ListItem>
                    ))}
                    <div className={styles.restMorediv}>
                        {/* <img src={openInputDiv ? bluePMinput : grayPMinput } onClick={handleInputDiv} alt="Open input div" className={styles.inpBtn} /> */}
                        <img src={resetBtn} onClick={resetFilter} alt="Reset Filters" className={styles.refFilter} />
                        <OverflowMenu
                            menuItems={[
                                {
                                    label: 'More Filters',
                                    icon: Filters,
                                    onClick: handleFilterDrawer,
                                },
                                {
                                    label: 'Customise',
                                    icon: Slider,
                                    onClick: handleCustomizeDrawer,
                                },
                                {
                                    label: 'Export',
                                    icon: Excel,
                                    onClick: exportToExcel,
                                },
                            ]}
                        />
                    </div>
                </div>
                <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }} className={styles.grid}>
                    <Grid size={{ xs: 12, sm:3, md: 2}} className={styles.cbubtnDiv}>
                        <CustomButton icon={Plus} label="Add new CBU" type="addCbu" onClick={toggleDrawer} />
                    </Grid>
                    <Grid size={{ xs: 12, sm:9, md:10}} className={styles.inputDiv}>
                        <FormControl>
                            {/* <label id="priority" className={styles.prioritylbl}>Priority</label> */}
                            <RadioGroup
                                row
                                aria-labelledby="priority"
                                name="priority"
                                value={selectedPriority}
                                onChange={handlePriorityChange}
                            >
                                <FormControlLabel 
                                    value="Prio 1" 
                                    control={<Radio size="small" sx={{
                                        '& .MuiSvgIcon-root': {
                                        fontSize: 14,
                                        },
                                    }}/>}
                                    label="Prio 1"
                                    sx={{'& .MuiFormControlLabel-label': {
                                        fontSize: 12,
                                        }
                                    }}
                                />
                                <FormControlLabel 
                                    value="Prio 2" 
                                    control={<Radio size="small" sx={{
                                        '& .MuiSvgIcon-root': {
                                        fontSize: 14,
                                        },
                                    }}/>} 
                                    label="Prio 2"
                                    sx={{'& .MuiFormControlLabel-label': {
                                        fontSize: 12,
                                        }
                                    }}
                                />
                                <FormControlLabel 
                                    value="Prio 3" 
                                    control={<Radio size="small" sx={{
                                        '& .MuiSvgIcon-root': {
                                        fontSize: 14,
                                        },
                                    }}/>} 
                                    label="Prio 3" 
                                    sx={{'& .MuiFormControlLabel-label': {
                                        fontSize: 12,
                                        }
                                    }}
                                />
                            </RadioGroup>
                        </FormControl>
                        <ListItem key={weekDropDownObj.label} className={styles.listWeek}>
                            <MultiSelectWithSearchInput
                                key={weekDropDownObj?.label}
                                label={weekDropDownObj?.label}
                                options={weekDropDownObj?.data}
                                filterValues={weekDropDownObj?.selectedData}
                                handleFilter={handleWeeknoChange}
                                disabled={false}
                                isLabelShow={true}
                            />
                        </ListItem>
                        <CustomButton 
                            label={isSubmit ? 'Wait...' : 'Submit'} 
                            type="priortizeSubmit" 
                            onClick={() => priortizationMatrixUpdate()} 
                            disabled={isSubmit}
                        />                        
                    </Grid>
                    <Grid size={{ xs: 12}}>
                        <MatrixTable 
                            tableColumns={tableColumns?.filter(col=> !['Weekly MSTN', 'Daily MSTN', 'Weekly OI', 'Daily OI']?.includes(col?.label))}
                            subHeaderColumn={tableColumns?.filter(col=> ['Weekly MSTN', 'Daily MSTN', 'Weekly OI', 'Daily OI']?.includes(col?.label))}
                            displayData = {tableData}
                            subTotal = {subTotal}
                            sentCheckBoxValues={getSelectedCheckBoxValue}
                            loading={isTableLoading}
                            handlePriorityChangeByDropdown={handlePriorityChangeByDropdown}
                            onSort={handleTableSort}
                            sortBy={sortBy}
                            sortOrder={sortOrder}
                            fieldSection={fieldSection}
                        />
                    </Grid>
                    <Grid size={{xs:12}} className={styles.inputDiv}>
                        {!firstApiCall && <TablePagination
                            rowsPerPageOptions={[]}
                            component="div"
                            count={totalRows}
                            rowsPerPage={rowsPerPage}
                            page={page} // Convert to 0-based
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            sx={{
                                padding: 0,
                                overflow: "hidden",
                                "& .MuiTablePagination-toolbar": {
                                    minHeight: "20px",
                                    fontSize: "12px",
                                },
                                "& .MuiTablePagination-select": {
                                    fontSize: "12px"
                                },
                                "& .MuiTablePagination-selectLabel": {
                                    fontSize: "12px"
                                },
                                "& .MuiTablePagination-displayedRows": {
                                    fontSize: "12px"
                                },
                                "& .MuiTablePagination-actions": {
                                    marginLeft: "10px"
                                },
                                "& .MuiIconButton-root": {
                                    fontSize: "14px"
                                },
                                "& .MuiSvgIcon-root": {
                                    height: "14px",
                                    width: "14px",
                                    fontSize: "14px"
                                },
                            }}
                        />}
                    </Grid>
                    
                </Grid>
                </>}
            </div>
            {/* Alert message show */}
            {snackBarObject.snackbarOpen && (
                <SnackBarMessage
                    type={snackBarObject.type}
                    snackbarMessage={snackBarObject.message}
                    snackbarOpen={snackBarObject.snackbarOpen}
                    setSnackbarOpen={closeSnackbar}
                />
            )}
            {/* add new CBU drawer component */}
            {isDrawerOpen && 
                <PrioritizeAddNewCBU 
                    anchor="right"
                    open = {isDrawerOpen}
                    closeDrawer = {toggleDrawer}
                    filterSiteCode = {filterObject?.find(item=>item?.label === 'Site code')?.selectedData}
                    afterAdd={addAfter}
                />
            }
            {/* More Filters */}
            {moreFilterLoader && <MoreFilters
                anchor="right"
                filterDrawer={moreFilterLoader}
                handleFilterDrawer={handleFilterDrawerClose}
                rmpmFilters={filterObject}
                setRmpmFilters={(filters) => {
                    // Check if there are any selected filters
                    const hasSelection = filters.some((filter) => {
                        const selected = filter?.selectedData;
                        if (Array.isArray(selected)) return selected.length > 0;
                        if (typeof selected === 'string') return selected.trim().length > 0;
                        return selected !== undefined && selected !== null;
                    });
                    
                    clearFiltersRef.current = !hasSelection;
                    setFilterObject(filters);
                }}
                username={activeAccount.username}
                type={pageType}
                options={filterObjectOption}
                onFiltersSaved={handleFiltersSaved}
            />}
            {/* customise column */}
            {customiseLoader && <CustomiseColumns
                anchor="right"
                columns={tableColumns}
                isOpen={customiseLoader}
                defaultColumns={['Site code', 'CBU code']}
                handleCustomizeDrawer={handleCustomizeDrawer}
                columnCustomization={columnCustomization}
                username={activeAccount.username}
                type={pageType}
            />}
            {/* export loader */}
            {exportLoader && <ExportLoader type={'Dynamic Prioritization'}/>}
        </Fragment>
    );
}
export default PriortizationMatrix;